import React, { useContext, useEffect, useRef, useState } from 'react';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Form,
  Button as GridButton,
  Toolbar,
  Item as GridItem,
  DataGridRef,
  Popup,
  Lookup,
  HeaderFilter
} from 'devextreme-react/data-grid';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { Button } from 'devextreme-react';
import { usePuntiDiRaccoltaDataSource } from '../../datasources/PuntiDiRaccoltaDataSource';
import PuntoDiRaccoltaEditPopup, { PuntoDiRaccoltaEditPopupHandle } from '../../components/puntoDiRaccoltaEdit/PuntoDiRaccoltaEditPopup';

export default function PuntiDiRaccolta() {
  const dataSource = usePuntiDiRaccoltaDataSource();
  const operatoreEditPopupRef = useRef<PuntoDiRaccoltaEditPopupHandle>(null);
  const gridRef = useRef<DataGridRef>(null);

  const refreshGrid = () => { gridRef.current?.instance().refresh(); }

  function openPuntoDiRaccoltaEditPopup(e: any) {
    operatoreEditPopupRef.current?.edit(e.row.key, `${e.row.data.nome}`);
  }

  function openPuntoDiRaccoltaNewPopup(e: any) {
    operatoreEditPopupRef.current?.new();
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Punti di raccolta</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>

          <DataGrid
            dataSource={dataSource}
            onDataErrorOccurred={dataGridErrorHandling}
            ref={gridRef}
            onRowUpdating={function (e) {
              e.newData = Object.assign({}, e.oldData, e.newData);
            }}
          >
            <Editing
              mode="popup"
              allowUpdating={true}
              allowAdding={true}
              allowDeleting={true}>
            </Editing>
            <HeaderFilter visible={true} allowSearch={true} />
            <Column type='buttons' alignment='left'>
              <GridButton name="edit" onClick={openPuntoDiRaccoltaEditPopup} />
              <GridButton name="delete" />
            </Column>

            <Column dataField="nome" caption="Nome" />
            <Column dataField="comune" caption="Comune" hidingPriority={5}/>
            <Column dataField="indirizzo" caption="Indirizzo" hidingPriority={4}/>
            <Column dataField="numeroCivico" caption="Numero civico" hidingPriority={3}/>
            <Column dataField="localita" caption="Localita" hidingPriority={2} />
            <Column dataField="telefono" caption="Telefono" hidingPriority={1}/>
            <Column dataField="cellulare" caption="Cellulare" hidingPriority={0} />

            <Toolbar>
              <GridItem location="after">
                <Button
                  icon='add'
                  //hint='Invia un invito per un nuovo utente'
                  stylingMode="text"
                  onClick={openPuntoDiRaccoltaNewPopup}
                />

              </GridItem>
            </Toolbar>
          </DataGrid>


        </div>
      </div>

      <PuntoDiRaccoltaEditPopup ref={operatoreEditPopupRef} onDataChanged={refreshGrid} />
    </React.Fragment>
  )
}
